import { Box, Card, Grid, Typography } from "@mui/material"
import { UserManagementIcon, ProjectManagementIcon } from "../../components/icons/CustomIcons"
import {
    Company24, Project24, Company36, Project36, User24, User36,
    Aicamera48, Aicamera36, Usermngement24, Camera24, Camera36,
    Companyoutline48, Timelapsecamera48, Livecamera36, Livecamera48
} from "../../components/icons/Icons"

const RoundBar = ({ title, count, icon, onClick, isSuperAdmin }) => {
    const small = isSuperAdmin ? "" : "-small"
    return (
        <Box onClick={onClick} className={`rounded-lg shadow status-card${small}`}
            sx={{
                width: 1,
                display: 'flex', alignItems: 'center',
                justifyContent: { xs: 'column', sm: 'space-between' },
                flexDirection: { xs: 'column', sm: isSuperAdmin ? 'row' : 'row-reverse' },
            }}
        >
            <Box className={`rounded-lg bg-light-gray dark-gray counter`}
                sx={{ fontWeight: 600 }}>
                {count}
            </Box>
            <Typography className={`dark-gray text`} width={1} sx={{ fontSize: 20, px: 1, fontWeight: 500, textAlign: { xs: 'center', sm: 'left' } }}>{title}</Typography>
            <Box sx={{ display: { xs: 'none', sm: 'block' }, textAlign: 'right' }}>{icon}</Box>

        </Box>

    )
}

const StatusCard = ({ datas, onCardClick, isSuperAdmin = false, userType }) => {
    const col = isSuperAdmin ? { xs: 6, sm: 6 } : { xs: 12, sm: 12 }
    const space = !isSuperAdmin ? 2 : '4.332vmin'
    const height = !isSuperAdmin ? 84 : 114
    const iconSize = !isSuperAdmin ? 24 : 48
    const data = {}
    datas?.forEach(element => {
        if (element.name === 'Company') {
            data.company_count = element.count
        } else if (element.name === 'User') {
            data.user_count = element.count
        } else if (element.name === 'Camera') {
            data.camera_count = element.count
        } else if (element.name === 'Project') {
            data.project_count = element.count
        }

    });
    return (<>
        <Grid container spacing={space} mb={2}>
            {isSuperAdmin && <Grid item size={col}>
                <RoundBar isSuperAdmin={isSuperAdmin} space={space} height={height} title="Clients" count={data.company_count || 0} icon={<Companyoutline48 size={iconSize} className="dark-gray" />} onClick={() => onCardClick('company')} />
            </Grid>}

            {userType != 0 && <>
                <Grid item size={col}>
                    <RoundBar isSuperAdmin={isSuperAdmin} space={space} height={height} title="Services" count={data.project_count || 0} icon={<Project36 size={iconSize} className="dark-gray" />} onClick={() => onCardClick('project')} />
                </Grid>

                <Grid item size={col}>
                    <RoundBar isSuperAdmin={isSuperAdmin} space={space} height={height} title="Tasks" count={data.user_count || 0} icon={<User36 size={iconSize} className="dark-gray" />} onClick={() => onCardClick('user')} />
                </Grid>
                <Grid item size={col}>
                    <RoundBar isSuperAdmin={isSuperAdmin} space={space} height={height} title="Documents" count={data.camera_count || 0} icon={<Camera36 size={iconSize} className="dark-gray" />} onClick={() => onCardClick('camera')} />
                </Grid>
            </>}



            {userType == 0 && <>
                <Grid item size={col}>
                    <RoundBar isSuperAdmin={isSuperAdmin} space={space} height={height} title="Surveillance cameras" count={data.camera_count || 0} icon={<Livecamera48 variant="outline" className="dark-gray" />} onClick={() => onCardClick('camera')} />
                </Grid>
                <Grid item size={col}>
                    <RoundBar isSuperAdmin={isSuperAdmin} space={space} height={height} title="Timelapse cameras" count={data.camera_count || 0} icon={<Timelapsecamera48 variant="outline" className="dark-gray" />} onClick={() => onCardClick('camera')} />
                </Grid>
                <Grid item size={col}>
                    <RoundBar isSuperAdmin={isSuperAdmin} space={space} height={height} title="AI Cameras" count={data.camera_count || 0} icon={<Aicamera48 variant="outline" className="dark-gray" />} onClick={() => onCardClick('camera')} />
                    {/* {JSON.stringify(data)} */}

                </Grid>
            </>}
        </Grid>
    </>
    )
}

export default StatusCard